/**
 * Faceta «Telas e configuração» — computação LOCAL sobre `resolveNav`.
 *
 * Zero request. É isto que faz a paleta parecer instantânea antes de qualquer
 * resposta de rede voltar — requisito de percepção da spec §5, não detalhe de
 * implementação. Com 1 caractere já há resposta na tela.
 *
 * Só entra item `active`. `soon` não leva a lugar nenhum e `locked` é teaser de
 * tier: um localizador que devolve destino inalcançável é pior que um que
 * devolve menos (spec §9, limite 5).
 *
 * A capability já foi aplicada por `resolveNav` — este hook não re-decide
 * autorização, só filtra por termo e por estado.
 */
import { useMemo } from 'react';

import { useCapabilities } from '../../hooks/use-capability';
import { resolveNav } from '../navigation/nav-model';

import { foldTerm } from './fold-term';

import type { SpotlightItem } from './types';

export const SCREEN_MIN_CHARS = 1;

export function useScreenHits(term: string): SpotlightItem[] {
  const capabilities = useCapabilities();
  const folded = foldTerm(term);

  return useMemo(() => {
    if (folded.length < SCREEN_MIN_CHARS) return [];
    const out: SpotlightItem[] = [];
    for (const section of resolveNav(capabilities)) {
      for (const item of section.items) {
        if (item.state !== 'active' || item.to === undefined) continue;
        if (!foldTerm(item.label).includes(folded)) continue;
        out.push({
          key: `screen:${item.to}`,
          section: 'screens',
          label: item.label,
          meta: section.title,
          to: item.to,
        });
      }
    }
    return out;
  }, [capabilities, folded]);
}
